module.exports = __webpack_public_path__ + "img/racetrack-greyville-turf.8367c2de.svg";